var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "creations-box d-flex flex-column",
      class: { "pt-0 pr-0 pl-0": _vm.creatorStudio.isMobile },
    },
    [
      _vm.completedJobs.length === 0
        ? _c("p", { staticClass: "p-3 d-flex" }, [
            _c("span", { staticClass: "alert alert-info" }, [
              _vm._v(_vm._s(_vm._f("trans")("Nothing created yet"))),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.completedJobs, function (completedJob) {
        return _vm.completedJobs.length > 0
          ? _c(
              "div",
              {
                key: completedJob.uuid,
                staticClass: "job-item d-flex flex-column p-20",
              },
              [
                _c("div", { staticClass: "d-flex gap-10 flex-column" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex gap-10 justify-content-between align-items-center",
                    },
                    [
                      _c("div", { staticClass: "d-flex gap-10" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "grey-box d-flex align-items-center pl-0",
                          },
                          [
                            _c("img", {
                              attrs: {
                                alt: _vm.getStyleName(completedJob),
                                srcset: _vm.getStyleSrcset(completedJob),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openTab(completedJob)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "font-weight-bold cursor-pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.openTab(completedJob)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.getStyleName(completedJob))
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "grey-box d-flex align-items-center cursor-pointer",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "font-weight-bold",
                                on: {
                                  click: function ($event) {
                                    return _vm.openTab(completedJob)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.getRatio(completedJob)))]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "remove-job-item cursor-pointer",
                          on: {
                            click: function ($event) {
                              return _vm.remove(completedJob.id)
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "far fa-trash-alt lh-inherit",
                          }),
                          _vm._v(" Remove\n        "),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "prompt-info cursor-pointer",
                        on: {
                          click: function ($event) {
                            return _vm.openTab(completedJob)
                          },
                        },
                      },
                      [
                        _vm._m(0, true),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(completedJob.settings.prompt)),
                        ]),
                        _vm._v(" "),
                        completedJob.settings.activeTool === "similiarimage"
                          ? _c("span", { staticClass: "font-italic" }, [
                              _vm._v("Similiar Image"),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "job-result cursor-pointer",
                    on: {
                      click: function ($event) {
                        return _vm.openTab(completedJob)
                      },
                    },
                  },
                  _vm._l(completedJob.base64_output_images, function (image) {
                    return _c("div", { staticClass: "d-flex image" }, [
                      _c("img", { attrs: { src: image } }),
                    ])
                  }),
                  0
                ),
              ]
            )
          : _vm._e()
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("strong", [_vm._v("Prompt")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }